import i18n from "i18next";
import capitalize from "lodash/capitalize";
import { initReactI18next } from "react-i18next";
import { dayjs } from "utils/dates/dayjs";
import { devLog } from "utils/devtools/devLogging";

import enUS from "./translations/en-US.json";

export const currentLanguage = "en-US";
export const defaultDateFormat = "MMM Do, YYYY";
export const boldComponent = <b />;

void i18n.use(initReactI18next).init({
  defaultNS: "translation",
  fallbackLng: "en-US",
  interpolation: {
    escapeValue: false, // react is already safe from xss
  },
  lng: currentLanguage,
  ns: ["translation", "spog"],
  resources: {
    "en-US": enUS,
  },
});

export const formatDate = (value: unknown, _lng?: string, options?: Record<string, unknown>): string => {
  if (value instanceof Date || dayjs.isDayjs(value) || (typeof value === "string" && dayjs(value).isValid())) {
    try {
      let format = defaultDateFormat;
      if (options?.format === "with_time") {
        format = "MMM Do, YYYY, h:mm A";
      } else if (options?.format === "with_time_seconds") {
        format = "MMM Do, YYYY, h:mm:ss A";
      } else if (options?.format === "only_time") {
        format = "h:mm A";
      } else if (options?.format === "short_month") {
        format = "MMM D, YYYY";
      }

      return dayjs(value).format(format);
    } catch (error) {
      devLog({ extra: { error }, level: "error", message: "Error formatting date" });
      return String(value);
    }
  }
  return value as string;
};

const formatCapitalize = (value: unknown, _lng?: string, _options?: Record<string, unknown>): string => {
  if (typeof value === "string") {
    return value && capitalize(value);
  }
  return value as string;
};

const formatDefaults = (value: unknown, _lng?: string, options?: Record<string, unknown>): string => {
  const val = value as string;
  if (options?.default) {
    return val || (options.default as string);
  }
  return val;
};

i18n.services.formatter?.add("date", formatDate);
i18n.services.formatter?.add("capitalize", formatCapitalize);
i18n.services.formatter?.add("d", formatDefaults);

// no-dd-sa:typescript-best-practices/no-namespace
declare module "i18next" {
  interface CustomTypeOptions {
    defaultNS: "translation";
    resources: {
      spog: (typeof enUS)["spog"];
      translation: (typeof enUS)["translation"];
    };
  }
}
